/** Coalesce pointer events before reading layout; idle cards schedule no work. */
export function createSpotlightPointer(options: {
  requestFrame: (callback: () => void) => number;
  cancelFrame: (id: number) => void;
  bounds: () => { left: number; top: number; width: number; height: number };
  paint: (x: number, y: number) => void;
}) {
  let pending: { x: number; y: number } | null = null;
  let frame: number | null = null;
  let disposed = false;
  function reset() {
    if (frame !== null) options.cancelFrame(frame);
    frame = null;
    pending = null;
  }
  return {
    move(x: number, y: number) {
      if (disposed) return;
      pending = { x, y };
      if (frame !== null) return;
      frame = options.requestFrame(() => {
        frame = null;
        if (disposed || !pending) return;
        const rect = options.bounds();
        options.paint(
          Math.max(0, Math.min(rect.width, pending.x - rect.left)),
          Math.max(0, Math.min(rect.height, pending.y - rect.top)),
        );
        pending = null;
      });
    },
    reset,
    dispose() {
      disposed = true;
      reset();
    },
  };
}
